import Backbone from 'backbone';
import CommonFunction from '../../common/common';
import StateManager from '../../state_manager';

export default Backbone.View.extend({
  initialize(o) {
    this.model = o.model;
    this.em = o.config.em;
    this.parent = o.parent;
    this.url = o.gconfig.url;
    this.model.view = this;
  },

  events: {
    'click .ctrl_item': 'opencontrol'
  },

  template() {
    let url, status, name;
    url = this.model.get('icon_url') || '';
    url =
      url.indexOf('app/src/images/controls') > -1 ? this.url + '' + url : url;
    status = this.getControlStatus();
    name = this.model.get('display_name');
    return `
            <div class="top-div">
                <div class="img-wrp"><img src="${url}"></div>
                <div class="status ${status.color}">${status.value}</div>
            </div>
            <div class="bottom-div">
                <div class="name">${name}</div>
                
            </div>`;
  },

  opencontrol() {
    console.log('control to open');
    CommonFunction.showLoader();
    this.em.get('ControlManager').closeControlList();
    this.getComponent(this.model.get('control_id'));
  },

  getComponent(id) {
    var reqObj = {
      operation: 'getStudioControlByID',
      control_id: id
    };

    var onSuccess = function(resp) {
      resp = JSON.parse(resp);

      var data = JSON.parse(resp.mongoData);

      var dev_document = data.filter(function(element) {
        return element['doc_type'] == 'dev';
      })[0];

      var code = '';
      var html = dev_document.designer_html || '';
      var css = `<style>
            ${dev_document.designer_css || ''}
            </style>`;
      code = html + css;

      this.em.get('CssComposer').clear();
      this.em
        .get('DomComponents')
        .getWrapper()
        .set('content', '');
      this.em.setComponents(code.trim());
      StateManager.init(editor, dev_document.states_data);

      dev_document['group'] = this.model.get('group');
      dev_document['status'] = this.model.get('status');
      dev_document['isDeprecated'] = this.model.get('isDeprecated');
      dev_document['isOnMarketplace'] = this.model.get('isOnMarketplace');
      this.em.config['current_control'] = JSON.stringify(dev_document);
      this.em
        .get('Panels')
        .getPanel('controlName')
        .set(
          'prependContent',
          `<div class="name_containter">${this.model.get('display_name')}</div>`
        );
      CommonFunction.hideLoader();
    };
    var onAjaxError = function(data) {
      CommonFunction.hideLoader();
      if (data.status == 401) {
        CommonFunction.ShowVSAlert(
          'error',
          "It seems like you've been logged out."
        );
      }
    };

    CommonFunction.fnAjaxRequest(
      this.url + 'Handler/ControlEditorHandler.ashx',
      'POST',
      reqObj,
      onSuccess.bind(this),
      onAjaxError.bind(this)
    );
  },

  getControlStatus() {
    var status = { value: '', color: '' };
    if (this.model.get('isOnMarketplace')) {
      status.value = 'Marketplace';
      status.color = 'blue';
    } else if (this.model.get('isDeprecated')) {
      status.value = 'Deprecated';
      status.color = 'red';
    } else {
      status.value = this.model.get('status') ? 'Active' : 'Draft';
      status.color = this.model.get('status') ? 'green' : 'yellow';
    }
    return status;
  },

  hide() {
    this.$el.addClass('hide');
  },

  show() {
    this.$el.removeClass('hide');
  },

  render() {
    this.$el.append(this.template());
    this.$el.addClass('ctrl_item');
    return this;
  }
});
